// @flow

import 'core-js/modules/es.set';
import 'core-js/modules/es.map';
import 'core-js/modules/es.array.iterator';
import 'core-js/modules/es.array.find';
import 'core-js/modules/es.array.find-index';
import 'raf/polyfill';
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import 'font-awesome/css/font-awesome.min.css';
import Mobile from 'client/containers/Mobile';
import isMobile from 'client/utils/isMobile';
import Router from './routes/index';
import './styles';

ReactDOM.render(isMobile.any() ? <Mobile /> : <Router />, (document.getElementById('app') : any));
